import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//function LogoPage() {
  const LogoPage = () => {
  const [loadingDots, setLoadingDots] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLoadingDots((prevDots) => {
        const newDots = prevDots + '.';
        if (newDots.length === 4) {
          clearInterval(intervalId);
          navigate('/main');
        }
        return newDots;
      });
    }, 1000);

    // Cleanup-Funktion, um das Intervall zu stoppen, wenn die Komponente unmountet wird
    return () => clearInterval(intervalId);
  }, [navigate]);

  const pageStyle = {
    backgroundColor: '#FF8C00', // Dunkelorange
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontFamily: 'sans-serif',
  };

  const headingStyle = {
    fontSize: '3em',
    marginBottom: '10px',
  };

  const loadingStyle = {
    fontSize: '1.5em',
  };

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>Crypto King</h1>
      <p style={loadingStyle}>Loading{loadingDots}</p>
    </div>
  );
}

export default LogoPage;